var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LegalSiteArticle',{attrs:{"page":_vm.dmcaPage,"nav-page":"dmca"}})
}
var staticRenderFns = []

export { render, staticRenderFns }